import * as THREE from 'three';
import { servObj } from './init_glob.js';
import { hideLoaderElement, showLoaderElement } from './loaderElement.js';
import { textureProgressLoader } from './textureProgressLoader.js';
import { resizeHandler, toggleMenu } from './script.js';
//const scene = servObj.scene

const textureSize = {
    abris: {
        width: 538,
        height: 362,
    },
    arbor: {
        width: 1003,
        height: 926,
    },
    classico: {
        width: 460,
        height: 380,
    },
    house: {
        width: 782,
        height: 759,
    },
    litos: {
        width: 1329,
        height: 844,
    },
    old_town: {
        width: 695,
        height: 475,
    },
    parquet_1: {
        width: 362,
        height: 362,
    },
    parquet_2: {
        width: 362,
        height: 362,
    },
    parquet_3: {
        width: 260,
        height: 266,
    },
    petra: {
        width: 1285,
        height: 1053,
    },
    rectangle_1: {
        width: 600,
        height: 400,
    },
    rectangle_2: {
        width: 300,
        height: 300,
    },
    regata: {
        width: 1079,
        height: 908,
    },
    rigel: {
        width: 1308,
        height: 1093,
    },
    trio: {
        width: 1200,
        height: 1055,
    },
};

export const applyTile = (cb = null, isNewProject = false) => {
    if (isNewProject) servObj.tile = structuredClone(servObj.defaultTile);

    if (!cb) {
        showLoaderElement();
    }

    let pathMap = `./textures/${servObj.tile.activeTilePattern.pathName}/${servObj.tile.activeColor}.webp`;
    let pathNormalMap = `./textures/${servObj.tile.activeTilePattern.pathName}/n.webp`;
    let pathAoMap = `./textures/${servObj.tile.activeTilePattern.pathName}/ao.webp`;
    let pathRoughnessMap = `./textures/${servObj.tile.activeTilePattern.pathName}/r.webp`;

    const tile = servObj.scene.getObjectByName('flor_tile');
    if (!tile || !tile.material) return;

    const loaderManager = {};

    servObj.loaderManager = loaderManager;

    const calculateTotalProgress = () => {
        // let _total = 1
        // let _loaded = 0
        let answer = 0;

        for (let key in loaderManager) {
            let total = loaderManager[key].total;
            let loaded = loaderManager[key].loaded;
            answer += loaded / total / 5;
        }

        //console.log({answer})

        return answer;
    };

    const calculateProgress = () => {
        let total = 1;
        let loaded = 0;
        let c = 0;
        for (let key in loaderManager) {
            total += loaderManager[key].total;
            loaded += loaderManager[key].loaded;
            if (loaderManager[key].total == loaderManager[key].loaded) c++;
        }
        //console.log(c)
        if (c == 5 || c == 6) {
            // IMPORTANT!! CANNOT USE "Object.keys(loaderManager).length"

            //console.log('start', servObj.isFirstLoading);
            //let f = Date.now()

            setTimeout(
                () => {
                    allMaterialsLoaded();
                    isNewProject ? hideLoaderElement(true) : hideLoaderElement();
                    document.querySelector('.preloader_fon').style.width = `0%`;
                    document.querySelector('.loader-procent').innerText = `0%`;
                    servObj.isFirstLoading = false;
                    servObj.isApplySaved = false;

                    resizeHandler();
                    window.addEventListener('resize', resizeHandler);

                    cb && cb();
                    //console.log('end', Date.now() - f);
                },
                servObj.isFirstLoading || servObj.isApplySaved ? 3000 : 1000
            );
        }

        //console.log(servObj.isFirstLoading, total, loaded)

        if (servObj.isFirstLoading) {
            //document.querySelector(".preloader_filled").style.backgroundPosition = `${(0.2 - (calculateTotalProgress())* 0.2) * 100}% 0`
            document.querySelector('.preloader_fon').style.width = `${(0.8 + calculateTotalProgress() * 0.2) * 100}%`;
            document.querySelector('.loader-procent').innerText = `${Math.round(
                (0.8 + calculateTotalProgress() * 0.2) * 100
            )}%`;
        } else {
            //document.querySelector(".preloader_filled").style.backgroundPosition = `${(1 - calculateTotalProgress()) * 100}% 0`
            document.querySelector('.preloader_fon').style.width = `${calculateTotalProgress() * 100}%`;
            document.querySelector('.loader-procent').innerText = `${Math.round(calculateTotalProgress() * 100)}%`;
        }
    };

    servObj.calculateProgress = calculateProgress;

    textureProgressLoader(
        pathMap,
        (map) => {
            tile.material.needsUpdate = true;
            map.wrapS = THREE.RepeatWrapping;
            map.wrapT = THREE.RepeatWrapping;
            map.flipY = false;
            map.colorSpace = THREE.SRGBColorSpace;
            map.anisotropy = 16;
            tile.material.map = map;
        },
        (e) => {
            loaderManager['map'] = { total: e.total, loaded: e.loaded };
            calculateProgress();
        }
    );

    textureProgressLoader(
        pathNormalMap,
        (normalMap) => {
            normalMap.wrapS = THREE.RepeatWrapping;
            normalMap.wrapT = THREE.RepeatWrapping;
            normalMap.flipY = false;
            normalMap.anisotropy = 16;
            tile.material.normalMap = normalMap;
        },
        (e) => {
            loaderManager['normalMap'] = { total: e.total, loaded: e.loaded };
            calculateProgress();
        }
    );

    textureProgressLoader(
        pathAoMap,
        (aoMap) => {
            aoMap.wrapS = THREE.RepeatWrapping;
            aoMap.wrapT = THREE.RepeatWrapping;
            aoMap.flipY = false;
            aoMap.anisotropy = 16;
            tile.material.aoMap = aoMap;
        },
        (e) => {
            loaderManager['aoMap'] = { total: e.total, loaded: e.loaded };
            calculateProgress();
        }
    );

    textureProgressLoader(
        pathRoughnessMap,
        (roughnessMap) => {
            roughnessMap.wrapS = THREE.RepeatWrapping;
            roughnessMap.wrapT = THREE.RepeatWrapping;
            roughnessMap.flipY = false;
            roughnessMap.anisotropy = 16;
            tile.material.roughnessMap = roughnessMap;
        },
        (e) => {
            loaderManager['roughnessMap'] = { total: e.total, loaded: e.loaded };
            calculateProgress();
        }
    );

    const allMaterialsLoaded = () => {
        if (servObj.tile && servObj.tile.activeGroupName) {
            const groupName = servObj.tile.activeTilePattern.pathName;
            const fractureName = servObj.tile.activeFacture.name;

            if (
                fractureName == 'Гранит' ||
                fractureName == 'Арбор' ||
                fractureName == 'Мрамор' ||
                fractureName == 'Искусственный камень'
            ) {
                tile.material.normalScale.x = 2;
                tile.material.normalScale.y = 2;
                tile.material.roughness = 1.4;
            } else {
                tile.material.normalScale.x = 1;
                tile.material.normalScale.y = 1;
                tile.material.roughness = 0.9;
            }
            if (textureSize[groupName]) {
                tile.material.map.repeat = new THREE.Vector2(
                    1000 / textureSize[groupName].width,
                    1000 / textureSize[groupName].height
                );
                tile.material.normalMap.repeat = new THREE.Vector2(
                    1000 / textureSize[groupName].width,
                    1000 / textureSize[groupName].height
                );
                tile.material.aoMap.repeat = new THREE.Vector2(
                    1000 / textureSize[groupName].width,
                    1000 / textureSize[groupName].height
                );
                tile.material.roughnessMap.repeat = new THREE.Vector2(
                    1000 / textureSize[groupName].width,
                    1000 / textureSize[groupName].height
                );
            }
        }
    };

    // Border

    const activeCollection = servObj.tile.activeCollection;
    const cls = activeCollection.depth[servObj.tile.activeDepth];
    const borderTextureName = cls.colors.find((cl) => cl.colorName == servObj.tile.activeColor).border;

    textureProgressLoader(
        `./textures/border/${borderTextureName}.jpg`,
        (borderMap) => {
            const border = servObj.scene.getObjectByName('flor_tile_curb');
            if (border) {
                border.material.map = borderMap;
                border.material.map.wrapS = THREE.RepeatWrapping;
                border.material.map.wrapT = THREE.RepeatWrapping;
                border.material.map.anisotropy = 16;
                border.material.map.colorSpace = THREE.SRGBColorSpace;
                border.material.map.flipY = false;
                border.material.map.repeat = new THREE.Vector2(100, 100);
                border.material.map.offset = new THREE.Vector2(0, -99);

                border.material.needsUpdate = true;
            }
        },
        (e) => {
            loaderManager['borderMap'] = { total: e.total, loaded: e.loaded };
            calculateProgress();
        }
    );
};

document.querySelector('#apply-tile').addEventListener('pointerdown', () => applyTile());
document.querySelector('#apply-tile-mobile').addEventListener('pointerup', () => {
    applyTile();
    toggleMenu(false);
});
